module.exports = __webpack_public_path__ + "static/media/pdf.cf7e19a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/pdf.svg
// module id = 968
// module chunks = 0